var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountVerificationProgress({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C3.1325 14 0 10.8675 0 7C0 3.1325 3.1325 0 7 0C10.8675 0 14 3.1325 14 7C14 10.8675 10.8675 14 7 14ZM7 0.933333C3.65167 0.933333 0.933333 3.65167 0.933333 7C0.933333 10.3483 3.65167 13.0667 7 13.0667C10.3483 13.0667 13.0667 10.3483 13.0667 7C13.0667 3.65167 10.3483 0.933333 7 0.933333ZM7 12.1333C4.165 12.1333 1.86667 9.835 1.86667 7H7V1.86667C9.835 1.86667 12.1333 4.165 12.1333 7C12.1333 9.835 9.835 12.1333 7 12.1333Z",
    fill: "#FFB018"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountVerificationProgress);
export default __webpack_public_path__ + "static/media/account-verification-progress.7ccb4bc29d5cffdd6d395de9314ac14e.svg";
export { ForwardRef as ReactComponent };